import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Star } from 'lucide-react';
import TopBar from '../components/common/TopBar';
import api from '../services/api';
import { toast } from 'sonner';

const ReviewOrder = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const submit = async () => {
    if (rating === 0) {
      toast.error('Selecione uma avaliação');
      return;
    }
    setSubmitting(true);
    try {
      // Get order to extract kiosk_id
      const { data: order } = await api.get(`/orders/${orderId}`);
      await api.post('/reviews', {
        order_id: orderId,
        kiosk_id: order.kiosk_id,
        rating,
        comment: comment || null,
      });
      toast.success(t('reviews.thankYou'));
      navigate('/orders');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erro ao enviar');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-background" data-testid="review-page">
      <TopBar title={t('reviews.rateYourOrder')} showBack />

      <div className="max-w-md mx-auto p-4 space-y-4">
        <div className="bg-white rounded-2xl border border-border p-6 text-center">
          <div className="text-5xl mb-3">⭐</div>
          <h2 className="font-['Outfit'] text-xl font-bold mb-2">{t('reviews.howWas')}</h2>
          <div className="flex justify-center gap-2 my-4">
            {[1, 2, 3, 4, 5].map((star) => (
              <button
                key={star}
                data-testid={`star-${star}`}
                onClick={() => setRating(star)}
                onMouseEnter={() => setHover(star)}
                onMouseLeave={() => setHover(0)}
                className="transition-transform hover:scale-110 active:scale-95"
              >
                <Star
                  className={`w-12 h-12 ${
                    star <= (hover || rating)
                      ? 'fill-primary text-primary'
                      : 'text-muted-foreground/30'
                  }`}
                />
              </button>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-xl border border-border p-4">
          <label className="block text-sm font-medium mb-2">{t('reviews.comment')}</label>
          <textarea
            data-testid="comment-input"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder={t('reviews.commentPlaceholder')}
            rows={4}
            className="w-full px-3 py-2 border border-border rounded-xl focus:outline-none focus:ring-2 focus:ring-primary resize-none"
          />
        </div>

        <button
          data-testid="submit-review"
          onClick={submit}
          disabled={submitting || rating === 0}
          className="w-full py-3 bg-primary text-primary-foreground rounded-full font-semibold disabled:opacity-50 active:scale-95"
        >
          {submitting ? t('checkout.processing') : t('reviews.submit')}
        </button>
      </div>
    </div>
  );
};

export default ReviewOrder;
